<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol class="ps-5" type="1">
      @for (stage of occupation?.stages; track $index) {
        <li class="mb-4">
          <div class="row">
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage?.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage?.endDate | date }}
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Ilość dni:">
                {{ stage.dayQuantity }}
              </app-label>
            </div>
          </div>
          <br>
          <table class='table table-silver'>
            <thead>
            <th>
              Rodzaj reklamy
            </th>
            <th>
              Oświetlenie reklamy
            </th>
            <th>
              Typ reklamy
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ stage.adKind }}
              </td>
              <td>
                {{ stage.adLightingType }}
              </td>
              <td>
                {{ stage.adType }}
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <table class='table table-silver'>
            <thead>
            <th>
              Szerokość reklamy (m)
            </th>
            <th>
              Długość reklamy (m)
            </th>
            <th>
              Ilość (szt)
            </th>
            <th>
              Łączna powierzchnia reklamy (m<sup>2</sup>)
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ stage.adWidth }}
              </td>
              <td>
                {{ stage.adLength }}
              </td>
              <td>
                {{ stage.adQuantity }}
              </td>
              <td>
                {{ stage.adArea }}
              </td>
            </tr>
            </tbody>
          </table>
          <br>
          <div class="row">
            <div class="col-12">
              <app-label label="Konstrukcja mocowania reklamy:">
                {{ stage.adMountingStructure }}
              </app-label>
            </div>
          </div>
          <br>
          <dl>
            <dt class="mb-3">
              <strong>Działki</strong>
            </dt>
            <dd>
              <app-parcels-preview [parcels]="stage.parcels || []"></app-parcels-preview>
            </dd>
          </dl>
          <br>
          <div class="row">
            <div class="col-12">
              <app-label label="Geometria:">
                {{ stage?.geometry ? 'Tak' : 'Nie' }}
              </app-label>
            </div>
          </div>
          <table class="table table-silver">
            <thead>
            <th>
              Nazwa drogi
            </th>
            <th>
              Numer drogi
            </th>
            <th>
              Ulica
            </th>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ stage.roadName }}
              </td>
              <td>
                {{ stage.roadNumber }}
              </td>
              <td>
                {{ stage.street || '-' }}
              </td>
            </tr>
            </tbody>
          </table>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>
